import script from "./seize.vue?vue&type=script&setup=true&lang=js"
export * from "./seize.vue?vue&type=script&setup=true&lang=js"

import "./seize.vue?vue&type=style&index=0&id=54bdc1d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54bdc1d6"]])

export default __exports__